import { PAYMENT_ACCOUNT_TYPES } from 'Data/constants.js'
import { numberMoney, personName } from 'Data/format.js'

export function getPayorName(payment_account) {
  if (!payment_account) return ''

  switch (payment_account.account_type) {
    case PAYMENT_ACCOUNT_TYPES.Person:
      return personName(payment_account.person_payment_account?.payer_person)
    case PAYMENT_ACCOUNT_TYPES.Insurance:
      return payment_account.insurance_payment_account?.insurance_company
        ?.carrier_name
    default:
      return '-'
  }
}
